var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedAtentionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#EC6655"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33417 4.74387L9.81902 11.3714C9.81902 11.7907 10.0614 12.0004 10.5463 12.0004H13.4554C13.9402 12.0004 14.1827 11.7907 14.1827 11.3714L14.6675 4.74387C14.6675 4.51512 14.5867 4.34356 14.4251 4.22918C14.3039 4.07668 14.1422 4.00043 13.9402 4.00043H10.0614C9.85942 4.00043 9.6776 4.07668 9.51599 4.22918C9.39477 4.34356 9.33417 4.51512 9.33417 4.74387Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.001 14.6674C12.7353 14.6674 13.3537 14.938 13.8561 15.479C14.3972 15.9814 14.6677 16.5998 14.6677 17.3341C14.6677 18.0684 14.3972 18.7061 13.8561 19.2471C13.3537 19.7495 12.7353 20.0008 12.001 20.0008C11.2667 20.0008 10.629 19.7495 10.088 19.2471C9.58556 18.7061 9.33435 18.0684 9.33435 17.3341C9.33435 16.5998 9.58556 15.9814 10.088 15.479C10.629 14.938 11.2667 14.6674 12.001 14.6674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedAtentionIcon);
export default __webpack_public_path__ + "static/media/red-atention-icon.caa17783dc96bd546a941033060cb55d.svg";
export { ForwardRef as ReactComponent };